<template id="sq-question">
  <div class="question-detail" v-if="questionDetail">
    <div class="detail-header">
      <div class="left-title">
        <span class="blue-block"></span>
        <span class="title-text">{{ $t('components.questionDetail.372231-0') }}</span>
      </div>
      <!-- <div class="right-feedback">
        <el-button type="primary" size="small" round plain @click="gotoFeedBack">意见反馈</el-button>
      </div> -->
    </div>
    <!--题目详情-->
    <div class="question-info" :class="[language == 'en' ? 'en-question-info' : '']">
      <div class="info-header">
        <ul class="left-side" @click.stop="viewKnowledgeDetail">
          <li class="knwoledge-name-box">
            <span>{{ $t('components.questionDetail.372231-1')}}</span>
            <el-popover
              placement="top-start"
              width="auto"
              trigger="hover">
              <span>{{knowledgeName}}</span>
              <span slot="reference" class="knwoledge-name">{{knowledgeName}}</span>
            </el-popover>
          </li>
          <li>
            <span>{{ $t('components.questionDetail.372231-2') }}</span>
            <span v-if="question_frequency">{{question_frequency}}</span>
            <span v-else>--</span>
            <span>{{ $t('components.questionDetail.372231-3') }}</span>
            <span v-if="question_difficulty">{{question_difficulty}}</span>
            <span v-else>--</span>
            <span>）</span>
          </li>
          <li>
            <span>{{ $t('components.questionDetail.372231-4') }}</span>
            <span v-if="questionDetail.module_code && subject_id == 2">【{{ getModuleName(questionDetail.module_code, questionDetail.module_count) }}】</span>
            <span v-else-if="questionDetail.module_name && subject_id != 2">【{{ questionDetail.module_name }}】</span>
            <span v-else>--</span>
          </li>
        </ul>
        <div class="right-side">
          <ul class="right-side-ul">
            <li v-if="questionDetail.recommend_type == 1">
              <span>【干扰题】</span>
            </li>
            <li class="type">
              <span>{{question_type_str}}</span>
              <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="copy-popper"
                >
                <div class="copy-id-box">
                  <span>ID：{{questionDetail.question_info.question_uuid}}</span>
                  <a class="copy-link"  @click="copyId(questionDetail.question_info.question_uuid)">{{ $t('components.questionDetail.372231-5') }}</a>
                </div>
                <i class="icon-id" slot="reference"></i>
              </el-popover>
            </li>
            <li v-if="!questionDetail.course_is_hide_diff">
              <span>{{ $t('components.questionDetail.372231-3') }}</span>
              <span v-if="questionDetail.user_exam_detail_info.difficulty">{{questionDetail.user_exam_detail_info.difficulty}}</span>
              <span v-else>--</span>
            </li>
            <li>
              <span>{{ $t('components.questionDetail.372231-6') }}</span>
              <span v-if="questionDetail.question_stats.answer_num">{{questionDetail.question_stats.answer_num}}{{ $t('components.questionDetail.372231-7') }}</span>
              <span v-else>--</span>
            </li>
            <li>
              <span>{{ $t('components.questionDetail.372231-8') }}</span>
              <span v-if="questionDetail.question_stats.correct_rate">{{questionDetail.question_stats.correct_rate}}%</span>
              <span v-else>--</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="question-content 11">
        <div v-if="titleContent" v-html="htmlDeCode(titleContent)" class="11"></div>
        <div v-if="translationText || originalText" class="translation-text">
          <p>{{translationText? '阅读译文' : '听力原文'}}</p>
          <div v-html="htmlDeCode(translationText || originalText)"></div>
        </div>
        <div v-katexUbb="htmlDeCode(qcontent)" class="22"></div>
        <template v-if="qimg&&qimg.length>0">
          <img v-for="(item,index) in qimg" :key="index" :src="item.source" alt="">
        </template>
        <div v-if="Array.isArray(hearing) && hearing.length" class="hearing-list">
          <div class="audio-box" 
          v-for="(audio,audio_index) in hearing"
          :key="audio_index"
          @click.stop="startHearPlay(audio.source_v2 || audio.source)">
            <i :class="[isHearPlay ? 'icon-horn-play' :  'icon-horn']"></i>
          </div>
        </div>

        <!--客观题的填空题-->
        <div class="fc-main 3" id="fc-main" v-if="q_forms == 2 && question_type === 3">
          <ul class="fillblock-wrap">
            <li
              :class="['fillblock', (block.right || block.isAnswer) ? 'right' : '', block.wrong ? 'wrong' : '']"
              v-for="(block, i) in questionfillBlocks"
              :key="i"
            >
              <span class="index">{{ i+1 }}</span>
              <template v-if="typeof (myAnswer[i]) !='undefined'">
                <div class="fill" v-if="subject_id == 1" v-html="Array.isArray(myAnswer) ? (myAnswer[i] != null ? myAnswer[i] : '') : myAnswer"></div>
                <div class="fill" v-else v-katex="htmlDeCode((myAnswer[i] || '')+'')"></div>
              </template>
              <div class="fill" v-else v-html="'&nbsp;'"></div>
              <span class="right-wrong-icon" v-if="block.right">
              <img src="../assets/images/right_q.png">
            </span>
              <span class="right-wrong-icon" v-if="block.wrong">
              <img src="../assets/images/wrong_q.png">
            </span>
            </li>
          </ul>
        </div>
        <!--/.主观题的填空题-->

        <div class="fc-main" v-else-if="question_type === 4">
          <ul class="fillblock-wrap">
            <div>
              <li class="fillblock fillblock1" :class="[judgeIsright?'right':'',judgeIsWrong?'wrong':'']">
                <div v-if="dataSource === 2">
                  <i class="status-icon" v-show="judgeIsright"><img src="../assets/images/right_q.png"/></i>
                  <i class="status-icon" v-show="judgeIsWrong"><img src="../assets/images/wrong_q.png"/></i>
                </div>
              </li>
            </div>
          </ul>
        </div>
        <!--选择题-->
        <ul class="options-wrap" v-else-if="question_type === 1 ||  question_type === 2">
          <li class="option-item" :class="[option.selected?'selected':'', option.isAnswer?'isAnswer':'', option.wrong?'wrong':'']" v-for="option in qOptions" :key="option.key">
            <div class="options-wrap__inner">
              <span class="option-num">{{option.key}}</span>
              <span class="option-content-wrap">
                <span class="option-content" v-if="option.content" v-katexUbb="htmlDeCode(option.content)"></span>
                <span class="option-content" v-else-if="isNumber(option.content)" v-katexUbb="htmlDeCode(option.content)"></span>
                <span class="option-content" v-else v-katexUbb="htmlDeCode(option.answer)"></span>
              </span>
              <div v-if="option.img_data && option.img_data.length > 0">
                <img :src="option.img_data[0]['source']">
              </div>
            </div>
            <i class="status-icon" v-show="option.right"><img src="../assets/images/right_q.png"/></i>
            <i class="status-icon" v-show="option.wrong"><img src="../assets/images/wrong_q.png"/></i>
          </li>
        </ul>
        <!--/.选择题-->

      </div>
      <div class="ques-devider"></div>
      <div class="answer-content">
        <div class="answer-header">
          {{ $t('components.questionDetail.372231-9') }}
          <span v-if="questionDetail.question_info.question_title_uuid && questionDetail.question_info.question_title_uuid != 0" class="topic-order">（第{{ questionDetail.question_info.question_order || 1 }}小题）</span>
        </div>
        <ul class="submit-answer-info">
          <li class="submit-item">
            <ul class="submit-module">
              <div v-if="fillqforms">
                <div v-if="subject_id != 3 && question_type === 3" class="answer-list answer-show">
                  <div class="answer-show-myanswer 11">{{ $t('components.questionDetail.372231-10') }}</div>
                  <!-- <div v-if="questionDetail.question_info && (questionDetail.user_exam_detail_info.is_right == -1 || questionDetail.user_exam_detail_info.is_right == 11) && ((questionDetail.question_info.audio_analysis != '' && questionDetail.question_info.audio_analysis != '[]') || (typeof myAnswer == 'string' && myAnswer.indexOf('.mp3') > 0)) && myAnswer !='' "> -->
                  <div v-if="($$(questionDetail,'user_exam_detail_info','is_right') == -1 || $$(questionDetail,'user_exam_detail_info','is_right') == 11) && typeof myAnswer == 'string' ">
                    <span v-if="myAnswer.toString().trim() == ''">{{ $t('Not Answered') }}</span>
                    <div v-else-if="subject_id == 1 && myAnswer.indexOf('.mp3') > -1" class="audio-box hearing-audio 133" @click.stop="startPlay(myAnswer)">
                      <i :class="[isPlay ? 'icon-horn-play' :  'icon-horn']"></i>
                    </div>
                    <span class="en123" v-else-if="subject_id == 1" v-html="myAnswer"></span>
                    <span v-else v-katex="htmlDeCode(myAnswer)"></span>
                  </div>

                  <div v-else class="my-answer-format 142" >
                    <div v-if="Array.isArray(myAnswer)">
                      <div v-for="(item, index) in myAnswer" :key="`answer_${index}`" :class="judgeStudentAnswer(index)">
                        <span v-if="item === null || String(item).trim() === ''">{{ $t('Not Answered') }}</span>
                        <template v-else>
                          <div v-if="item.endsWith('.mp3') && subject_id == 1" class="audio-box hearing-audio 133" @click.stop="startPlay(item)">
                            <i :class="[isPlay ? 'icon-horn-play' :  'icon-horn']"></i>
                          </div>
                          <span class="11" v-else-if="subject_id == 1" v-html="item"></span>
                          <span v-else v-katex="htmlDeCode(item)"></span>
                        </template>
                        <span v-if="index != (myAnswer.length - 1) && myAnswer.length > 1" class="comma">,</span>
                      </div>
                    </div>
                    <template v-else>
                      <div class="11" v-if="myAnswer.toString().trim() == ''">{{ $t('Not Answered') }}</div>
                      <div class="11" v-else-if="subject_id == 1" v-html="myAnswer"></div>
                      <div class="11" v-else v-katex="htmlDeCode(myAnswer)"></div>
                    </template>
                    <span v-if="showRevisedAnswer">（修正后答案）</span>
                  </div>
                </div>
                <div v-else-if="(subject_id ==3 && question_type === 3)" class="answer-list answer-show">
                  <div class="answer-show-myanswer 2">{{ $t('components.questionDetail.372231-10') }}</div>
                  <div class="my-answer-format" >
                    <div v-if="Array.isArray(myAnswer)">
                      <div v-for="(item, index) in myAnswer" :key="`answer_${index}`" :class="judgeStudentAnswer(index)">
                        <span v-katexUbb="htmlDeCode(item)"></span>
                        <span v-if="index != (myAnswer.length - 1) && myAnswer.length > 1" class="comma">,</span>
                      </div>
                    </div>
                    <div v-else v-katexUbb="!htmlDeCode(myAnswer).trim() ? $t('Not Answered') : htmlDeCode(myAnswer)"></div>
                  </div>
                </div>
                <div v-else-if="question_type === 9">
                  <div class="answer-show-myanswer 333" style="display: inline-block;">{{ $t('components.questionDetail.372231-10') }}</div>
                  <div class="my-answer-format" style="display: inline-block;">
                    {{ $$(questionDetail, 'user_exam_detail_info', 'child_game', 'correct_attempts') }} / {{ $$(questionDetail, 'user_exam_detail_info', 'child_game', 'total_attempts') }} (Correct Times/ Total Attempts)
                  </div>
                </div>
                <div v-else-if="question_type === 8" style="display: flex">
                  <div class="answer-show-myanswer flex-line">{{ $t('components.questionDetail.372231-10') }}</div>
                  <!-- 20251119 后端定义题目类型 1 选择题 2 多选题 3 填空题 6 判断题 7 写作 8 读音 9 低幼 -->
                  <div class="audio-box hearing-audio 133" @click.stop="startPlay(myAnswer)">
                      <i :class="[isPlay ? 'icon-horn-play' :  'icon-horn']"></i>
                    </div>
                </div>
                <div v-else class="answer-list answer-show">
                  <div class="answer-show-myanswer 33">{{ $t('components.questionDetail.372231-10') }}</div>
                  <div class="my-answer-format">
                    <div v-if="Array.isArray(myAnswer)">
                      <div v-for="(item, index) in myAnswer" :key="`answer_${index}`" :class="judgeStudentAnswer(index)">
                        <template v-if="Array.isArray($$(item,'content'))">
                          <p v-for="(childAnswer,childIndex) in $$(item,'content')" :key="`child_answer${childIndex}`">
                            <span v-if="typeof childAnswer === 'string' && htmlDeCode(childAnswer).indexOf('.mp3') > 0" class="audio-box" @click.stop="startPlay(htmlDeCode(childAnswer))">
                              <i :class="[isPlay ? 'icon-horn-play' :  'icon-horn']"></i>
                            </span>
                            <span v-else v-katexUbb="htmlDeCode((childAnswer || {}).content || childAnswer)"></span>
                          </p>
                        </template>
                        <template v-else>
                          <span v-katexUbb="htmlDeCode(String(item).trim() === '' ? $t('Not Answered') : item)"></span>
                        </template>
                        <span v-if="index != (myAnswer.length - 1) && myAnswer.length > 1" class="comma">,</span>
                      </div>
                    </div>
                    <div v-else v-katexUbb="htmlDeCode(myAnswer) ? htmlDeCode(myAnswer) : $t('history.index.273750-17')"></div>
                  </div>
                </div>
                <!-- <div class="correct-answer-wrap" v-if="first_submit_answer_format&&questionDetail.user_exam_detail_info && questionDetail.user_exam_detail_info.is_right == 1">
                  <span>{{ $t('components.questionDetail.372231-45') }}</span>
                  <span v-for="(item, index) in first_submit_answer_format.user_answer" :key="`answer_${index}`" :class="judgeStudentAnswer(index)" style="color: #444b65;">
                    <span v-if="item == ''">{{ $t('Not Answered') }}</span>
                    <template v-else>
                      <span class="11" v-if="subject_id == 1" v-html="item"></span>
                      <span v-else v-katex="htmlDeCode(item)"></span>
                    </template>
                    <span v-if="index != (first_submit_answer_format.user_answer.length - 1) && first_submit_answer_format.user_answer.length > 1" class="comma">,</span>
                  </span>
                </div>
                <div class="correct-answer-wrap" v-if="first_submit_answer_format&&questionDetail.user_exam_detail_info && questionDetail.user_exam_detail_info.is_right == 0">
                  <span>{{ $t('components.questionDetail.372231-46') }}</span>
                  <span v-for="(item, index) in first_submit_answer_format.user_answer" :key="`answer_${index}`" :class="judgeStudentAnswer(index)" style="color: #444b65;">
                      <span v-if="item == ''">{{ $t('Not Answered') }}</span>
                      <template v-else>
                        <span class="11" v-if="subject_id == 1" v-html="item"></span>
                        <span v-else v-katex="htmlDeCode(item)"></span>
                      </template>
                      <span v-if="index != (first_submit_answer_format.user_answer.length - 1) && first_submit_answer_format.user_answer.length > 1" class="comma">,</span>
                    </span>
                </div> -->
                <div class="correct-answer-wrap" v-if="showRevisedAnswer&&questionDetail.user_exam_detail_info">
                  <span class="first-submit-myanswer">首次答案：</span>
                  <span v-for="(item, index) in first_submit_answer_format.user_answer" :key="`answer_${index}`" :class="judgeStudentAnswer(index)" style="color: #444b65;">
                    <span v-if="item == ''">{{ $t('Not Answered') }}</span>
                    <template v-else>
                      <span class="11" v-if="subject_id == 1" v-html="item"></span>
                      <span v-else v-katex="htmlDeCode(item)"></span>
                    </template>
                    <span v-if="index != (first_submit_answer_format.user_answer.length - 1) && first_submit_answer_format.user_answer.length > 1" class="comma">,</span>
                  </span>
                  <div v-if="revise_extend_data && revise_extend_data.error_cause_type > 0">
                    （<span>Ai 错因分析：{{ revise_extend_data.error_cause_txt }} | {{ revise_extend_data.error_cause_sub_txt }}</span>
                    <span v-if="revise_extend_data.feedback_type > 0">；学生评论：{{ revise_extend_data.feedback_txt }}{{ revise_extend_data.feedback_type == 1 ? '👍' : '👎' }}</span>）
                  </div>
                </div>
              </div>
              <div class="imagebox">
                <div  class="image-box" v-viewer="{movable: false}">
                  <img v-for="(src, index) in questionDetail.attaches" :src="src" :key="`image_${index}`">
                </div>
                <div class="image-box2" >
                  <div class="mask" v-for="(src,index) in questionDetail.attaches" :key="`attaches_${index}`" @click="imgclick(index)">
                    <i class="icon-fdj"></i>
                  </div>
                </div>
              </div>
            </ul>
          </li>
          <li class="submit-item">
            <div v-if="question_type === 3" class="answer-show">
              <div class="answer-show-myanswer 4">{{ $t('components.questionDetail.372231-12') }}</div>
              <div v-if="qfillAnswer.length == 0">
                <span class="empty-line"></span>
              </div>
              <template v-else-if="qfillAnswer.length > 1">
                <div v-for="(item,index) in qfillAnswer" :key="index" class="right-answer">
                  <div v-for="(childItem, childIndex) in item" :key="childIndex" class="answer-list">
                    <div v-katex="formatAnswer(childItem.content)" class="katex-answer"></div>
                  </div>
                  <span v-if="index != (qfillAnswer.length - 1) && qfillAnswer.length > 1" class="comma">,</span>
                </div>
              </template>
              <template v-else-if="qfillAnswer.length == 1">
                <div v-for="(item,index) in qfillAnswer" :key="index" class="right-answer">
                  <div v-for="(li,index1) in item" :key="index1" class="answer-list 2 answer-list-flex">
                    <span v-html="formatAnswer(li.content)" v-if="subject_id == 1 ||  subject_id == 3"></span>
                    <span v-katex="formatAnswer(li.content)" v-else class="1111"></span>
                    <span>&nbsp;&nbsp;</span>
                    <!-- <span v-if="index1 < item.length - 1" class="margin-6">|</span> -->
                  </div>
                  <span v-if="index != (qfillAnswer.length - 1) && qfillAnswer.length > 1" class="comma">&nbsp;,&nbsp;</span>
                </div>
              </template>
            </div>
            <div v-else-if="question_type === 9" class="answer-show">
              <div class="answer-show-myanswer 4">{{ $t('components.questionDetail.372231-12') }}</div>Correct Questions/ Total Attempts ≥ 60%
            </div>
            <div v-else class="answer-show">
              <div class="answer-show-myanswer 5">{{ $t('components.questionDetail.372231-12') }}</div>
              <div v-if="Array.isArray(qAnswer)">
                <div v-for="(item, index) in qAnswer" :key="`q_answer${index}`">
                  <template v-if="Array.isArray($$(item,'content'))">
                    <p v-for="(childAnswer,childIndex) in $$(item,'content')" :key="`child_answer${childIndex}`">
                       <span v-html="childAnswer.content || childAnswer"></span>
                    </p>
                  </template>
                  <template>
                    <p v-html="item.content || item"></p>
                  </template>
                </div>
              </div>
              <div v-else-if="subject_id == 3 || subject_id ==1" v-html="qAnswer" class="my-answer-format"></div>
              <div v-else v-katex="formatAnswer(qAnswer)" class="my-answer-format"></div>
            </div>
          </li>
          <li class="submit-item detail-item-auxiliary" v-if="auxiliaryImgUrl && language == 'en'">
            <span>{{ $t('components.questionDetail.372231-13') }}</span>
            <div class="imagebox">
              <div  class="image-box 22">
                <img :src="auxiliaryImgUrl" :style="imgSize">
              </div>
              <div class="image-box2" >
                <div class="mask" @click="imgOpen(auxiliaryImgUrl)">
                  <i class="icon-fdj"></i>
                </div>
              </div>
            </div>
          </li>
          <li class="submit-item">
            <ul class="submit-module">
              <li>
                <span class="label-item">{{ $t('components.questionDetail.372231-14') }}</span>
                <span class="question-time" v-if="answer_behavior && answer_behavior['answer_duration']">{{formatAnswerTime(answer_behavior['answer_duration'])}}</span>
                <span class="time">{{ $t('components.questionDetail.372231-15') }}</span>
                <span>{{formatAnswerTime(questionDetail.question_info.estimates_time)}}）</span>
              </li>
              <!-- <li>
                <span class="label-item">第几次重答：</span>
                <span class="text-value">-</span>
              </li> -->
              <li v-if="questionDetail['kcode_relearn_cnt'] && questionDetail['kcode_relearn_cnt'] > 0">
                <span class="label-item">{{learning_version == 10 ? $t('components.questionDetail.372231-16') : $t('components.questionDetail.372231-17')}}</span>
                <span class="text-value">{{questionDetail['kcode_relearn_cnt']}}</span>
                <!-- <span class="text-value" v-else>--</span> -->
              </li>
            </ul>
          </li>
          <li class="submit-item">
            <ul class="submit-module">
              <li>
                <span class="label-item">{{ $t('components.questionDetail.372231-18') }}</span>
                <span class="text-value tips">{{ lookPrompt }}</span>
              </li>
              <!-- <li>
                <span class="label-item">是否查看解析：</span>
                <span class="text-value">-</span>
              </li> -->
            </ul>
          </li>
          <li v-if="language === 'zh' && questionDetail.user_exam_detail_info && questionDetail.user_exam_detail_info.is_right == 0 && errParams.subject_id && subject_id == 2"
           class="error-reason-wrap">
            <span class="mark">{{ $t('components.questionDetail.372231-19') }}</span>
            <error-reason-new
              :isEditReason="true"
              :apiUrl="apiUrl"
              :params="errParams">
            </error-reason-new>
          </li>
        </ul>
      </div>
    </div>
    <!--/.题目详情-->

    <!--草稿步骤-->
    <div class="question-analysis"  v-if="language == 'zh' && subject_id != 1 && subject_id != 3">
      <div class="module-header-title">
        <span class="color-block"></span>
        <span>草稿步骤</span>
      </div>
      <ul class="detail-ul">
          <li class="detail-item detail-item-auxiliary detail-item-auxiliary1"
            v-if="questionDetail && Array.isArray(questionDetail.source) && questionDetail.source.length > 0">
            <div class="imagebox imagebox1" v-for="(item,index) in questionDetail.source" :key="index">
              <div  class="image-box">
                <img :src="item.source_url" :style="imgSize">
              </div>
              <div class="image-box2" >
                <div class="mask" @click="imgOpen(item.source_url)">
                  <i class="icon-fdj"></i>
                </div>
              </div>
              <p>{{item.source_use_type == 'step_draft'?'步骤':(item.source_use_type == 'draft'?'草稿':'')}}</p>
            </div>
            <p class="margin-bottom-32" v-if="userNoDraft">用户未书写草稿</p>
            <p class="margin-bottom-32" v-if="userNoStepDraft && subject_id == 2">用户未书写步骤</p>
          </li>
          <li v-else class="detail-item detail-item-auxiliary detail-item-auxiliary1">
            <p class="margin-right-24">用户未书写草稿</p>
            <p class="margin-right-24" v-if="subject_id == 2">用户未书写步骤</p>
          </li>
      </ul>
    </div>
    <!--/.caog-->

    <!--题目解析-->
    <div class="question-analysis">
      <div class="module-header-title">
        <span class="color-block"></span>
        <span>{{ $t('components.questionDetail.372231-20') }}</span>
      </div>
      <div class="analysis-info">
        <ul class="analysis-header">
          <li :class="[analysisType == 'analysis' ? 'active' : '']" @click="showAnalysis('analysis')">{{ $t('components.questionDetail.372231-20') }}</li>
          <li :class="[analysisType == 'tips' ? 'active' : '']" @click="showAnalysis('tips')">{{ $t('components.questionDetail.372231-21') }}</li>
        </ul>
        <div v-if="analysisType == 'analysis'" class="analysis-text">
          <div class="analysis-section">
            <span class="label-text">{{ $t('components.questionDetail.372231-22') }}</span>
            <ul class="video-ul" v-if="Array.isArray(knowledgeVideo) && knowledgeVideo.length > 0">
              <li v-for="(item,index) in knowledgeVideo" :key="index">
                <el-button v-if="$$(item,'resource',0,'video_data','source_url_v2')" type="primary" size="small" round plain @click="viewVideo($$(item,'resource',0,'video_data','source_url_v2'))">{{ $t('components.questionDetail.372231-23') }}{{index+1}}</el-button>
              </li>
            </ul>
            <span v-else>--</span>
          </div>
          <div class="analysis-section">
            <span class="label-text">{{ $t('components.questionDetail.372231-24') }}</span>
            <ul class="video-ul" v-if="analyVideoArr.length > 0">
              <li v-for="(item, index) in analyVideoArr" :key="index">
                <el-button v-if="$$(item,'source_url_v2')" type="primary" size="small" round plain @click="viewVideo($$(item,'source_url_v2'))">{{ $t('components.questionDetail.372231-25') }}{{index+1}}</el-button>
              </li>
            </ul>
            <span v-else>--</span>
          </div>
          <div class="analysis-section">
            <span class="label-text">{{ $t('components.questionDetail.372231-26') }}</span>
            <div class="tu-wen-text" v-if="analyze.length > 0">
              <div v-for="(anlyItem, index) in analyze" :key="index">
                <div v-for="(anlyItemContent,index) in anlyItem" :key="index">
                  <div v-if="anlyItemContent.content" v-katexUbb="htmlDeCode(anlyItemContent.content)"></div>
                </div>
              </div>
            </div>
            <div class="tu-wen-text" v-else>--</div>
          </div>
        </div>
        <div v-else-if="analysisType == 'tips'" class="analysis-text">
          <div v-if="subject_id == 4 || subject_id == 5">
            <div v-if="prompt && prompt.length > 0 && prompt[0]">
              <div v-for="(promptItem, index) in prompt" :key="index">
                <div v-if="promptItem">
                  <div v-for="(promptItemContent,index) in promptItem" :key="index">
                    <div v-if="promptItemContent.content" v-katexUbb="htmlDeCode(promptItemContent.content)"></div>
                  </div>
                </div>
                <div v-else>
                  <div v-katexUbb="htmlDeCode(item)"></div>
                </div>
              </div>
            </div>
            <div v-else class="no-prompt">-</div>
          </div>
          <div v-else-if="subject_id == 2">
            <div v-if="analyze && analyze.length > 0">
              <div v-for="(analyItem, analyzeIndex) in analyze" :key="analyzeIndex">
                <div v-for="(item,index) in analyItem" :key="index">
                  <div v-if="item.content" v-katexUbb="htmlDeCode(item.title)"></div>
                </div>
              </div>
            </div>
            <div v-else class="no-prompt">-</div>
          </div>
        </div>
      </div>
    </div>
    <!--/.题目解析-->

    <!--标记错因-->
    <!-- <SignReason
      v-if="user_exam_detail_id"
      :user_exam_detail_id="user_exam_detail_id"
      :error_reason_list="error_reason_list"
    /> -->
    <!--/.标记错因-->

    <!--MCM-->
    <div class="mcm-module">
      <div class="module-header-title">
        <span class="color-block"></span>
        <span>MCM</span>
      </div>
      <div class="mcm-info">
        <div class="mcm-header">
          {{ $t('components.questionDetail.372231-32') }}
        </div>
        <div class="mcm-content">
          <div class="single-mcm">
            <span class="title">{{ $t('components.questionDetail.372231-33') }}</span>
            <ul class="mcm-content-ul"  v-if="thoughts && thoughts.length > 0">
              <li class="thought" v-for="(item, index) in thoughts" :key="`thoughts_${index}`">{{item.mcm_name || item.thoughts_name}}</li>
            </ul>
            <ul class="mcm-content-ul" v-else>
              <li>
                --
              </li>
            </ul>
          </div>
          <div class="single-mcm">
            <span class="title">{{ $t('components.questionDetail.372231-34') }}</span>
            <ul class="mcm-content-ul" v-if="factors && factors.length > 0">
              <li class="ability" v-for="(item, index) in factors" :key="`index_${index}`">{{item.mcm_name || item.factors_name}}</li>
            </ul>
            <ul class="mcm-content-ul" v-else>
              <li>
                --
              </li>
            </ul>
          </div>
          <div class="single-mcm">
            <span class="title">{{ $t('components.questionDetail.372231-35') }}</span>
            <ul class="mcm-content-ul" v-if="methods && methods.length > 0">
              <li class="function" v-for="(item, index) in methods" :key="`thoughts_${index}`">{{item.mcm_name || item.methods_name}}</li>
            </ul>
            <ul class="mcm-content-ul" v-else>
              <li>
                --
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--/.MCM-->
    <audio :src="currentAudioSrc" controls="controls" hidden="true"  id="myaudioDetail" autoplay="autoplay"></audio>
    <audio :src="currentAudioHearingSrc" controls="controls" hidden="true" id="myHearaudioDetail" autoplay="autoplay"></audio>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { getUserQuestionInfo, getBoardImg } from '@/api/base';
  import { htmlDecodeByRegExp, scienceHtmlDecodeByRegExp, decodeForAnswer } from '@/utils';
  import i18n from '@/i18n'
  import SignReason from '@/components/singReason';
  import errorReasonNew from '@/components/errorReasonNew';
  import langMap from '@/utils/lang-map';
  export default {
    name: "questionDetail",
    data () {
      return {
        question: '',
        analysisType: 'analysis',
        knowledgeName: '',
        knowledgeCode: '',
        showAnswerList: false,  // 显示解析部分
        question_type: '', // 试题类型  1：单选，2：多选，3：填空，4：判断，5：问答
        questionDetail: '',
        question_type_str: '',
        q_forms: '', // 题目形式，1主观，2客观
        qcontent: '',// 题目详情
        titleContent: '',//题干详情,
        translationText:'',//昂立英语阅读译文
        originalText:'',//昂立英语听力原文
        qimg: [],
        qOptions: [],//选择题选项
        currentAudioSrc: '',
        currentAudioHearingSrc: '',
        hearing: '',  // 是否有语音
        isPlay: false, // 是否播放中
        isHearPlay: false,
        fillqforms: true,
        myAnswer:'',// 题目我的答案
        qAnswer:'',// 选择题目正确答案
        answerList: [],// 返回答案的列表
        judgeAnswer: '',//判断题答案
        factors: [], // 能力
        thoughts: [], //思想
        methods: [], // 方法
        answer_behavior: {},
        knowledgeVideo: [], // 知识点视频
        analyze: [], // 解析
        judgeIsright: false,
        judgeIsWrong: false,
        questionfillBlocks: [],
        qfillAnswer: [],//填空题正确答案
        user_exam_detail_id: '',  // 是否有错因
        error_reason_list: [], // 错因的列表
        knowledge_info: '',
        analyVideoArr: [],  // 讲解视频
        isMultiSpaceRight: [], // 一题多空
        errParams: {},
        apiUrl: {
          errList: '/question/errorReasonList',
          errDefaultVal: '/question/getQuestionFeedbackDetail',
          addError: '/question/addUserFeedback'
        },
        auxiliaryImgSize: {},
        auxiliaryImgUrl: '', //https://cdn.classba.cn/public/robot/suntory/img/adv_bg.png',
        lesson_id: '',
        language: 'zh',
        userNoDraft:false,
        userNoStepDraft:false,
        answerNum: 0,
        correctRate: 0,
        difficulty: 0,
        reason: [], // 错因信息
        question_frequency: 0, // 知识点考频
        question_difficulty: 0, // 知识点难度
        currentCourseInfo: {}
      }
    },
    props: {
      subject_id: {
        required: true,
      },
      account_id: {
        required: true,
      },
      user_id: {
        required: true,
      },
      question_id: {
        required: true,
      },
      dataSource: {
        required: true,
      },
      course_id: {
        required: true,
      },
      Onequestiontype: {
        required: true,
      },
      serialNum: {
        required: true,
      },
      learning_version: {
        required: true,
      },
      topic_id: {
        required: false,
      }
    },
    computed: {
      ...mapGetters([
        'currentViewStudent'
      ]),
      videoUrlKey() {
        return this.$globalVideoType === 'mp4' ? 'video' : 'videoV2';
      },
      videosKey() {
        return this.$globalVideoType === 'mp4' ? 'videos' : 'videosV2';
      },
      first_submit_answer_format() {
        const firstSubmitAnswer = this.questionDetail.user_exam_detail_info?.first_submit_answer_format;
        return firstSubmitAnswer && !Array.isArray(firstSubmitAnswer) ? firstSubmitAnswer : null;
      },
      showRevisedAnswer () {
        return this.first_submit_answer_format?.extend_data?.is_used === 1;
      },
      // 修正卡扩展字段
      revise_extend_data () {
        return this.first_submit_answer_format?.extend_data || null;
      },
      imgSize () {
        return {
          width: this.auxiliaryImgSize.w,
          height: this.auxiliaryImgSize.h
        }
      },
      lookPrompt() {
        const { is_look_prompt_result,is_look_prompt } = this.answer_behavior;
        const lang = this.language;
        if (Number(is_look_prompt_result || 0) > 0) {
          return lang === 'zh' ? `看过${is_look_prompt_result}步` : `Viewed ${is_look_prompt_result} steps`;
        } else {
          if(is_look_prompt == 0){
            return lang === 'zh' ? '未看' : 'Not Viewed';
          }else{
            return lang === 'zh' ? '已看' : 'Viewed';
          }
        }
      },
    },
    components: { SignReason,errorReasonNew },
    created () {
      this.language = sessionStorage.getItem('Select-language') || 'zh'
      if(this.dataSource === 1 || this.question_type === 8){
        this.showAnswerList = true
      }

    },
    mounted () {
      this.queryQuestionInfo();
      // 初始化音频事件监听
      this.$nextTick(() => {
        this.initAudioListeners();
      });
    },
    beforeDestroy() {
      // 清理音频播放完成事件监听
      const myHearaudio = document.getElementById('myHearaudioDetail');
      const myAuto = document.getElementById('myaudioDetail');
      if (myHearaudio && this.handleHearAudioEnd) {
        myHearaudio.removeEventListener('ended', this.handleHearAudioEnd);
      }
      if (myAuto && this.handleAudioEnd) {
        myAuto.removeEventListener('ended', this.handleAudioEnd);
      }
    },
    methods: {
      judgeIsAudioQuestion(question){
        return true
      },
      getQuestionDiff(list){
        if(!Array.isArray(list)){
          return {}
        }
        const user_id = this.currentViewStudent.user_id;
        const study_info = JSON.parse(sessionStorage.getItem(user_id)) || {};
        const book_version = study_info.course_info && study_info.course_info.book_version;
        return list.find(item => item.textbook_id == book_version)
      },
      getModuleName (moduleCode, moduleCount) {
        const moduleName = langMap[this.language || 'zh'][moduleCode];
        if (moduleCount && moduleCount > 0) {
          if (this.language === 'zh') {
            return `第${moduleCount}次${moduleName}`;
          } else {
            return `Round ${moduleCount}`;
          }
        }
        return moduleName;
      },
      queryQuestionInfo () {
        getUserQuestionInfo({
          subject_id: this.subject_id,
          account_id: this.account_id,
          user_id: this.user_id,
          course_id: this.course_id,
          course_version: this.learning_version == 3 ? 10 : this.learning_version,
          serial_num: this.serialNum,
          question_id: this.question_id,
        }).then(res => {
          if (res.code == 200 && res.data) {
            this.questionDetail = res.data;

            // 处理新数据结构
            const questionInfo = res.data.question_info;
            const userExamDetailInfo = res.data.user_exam_detail_info;
            // 知识点信息
            if (questionInfo.knowledge && questionInfo.knowledge.length > 0) {
              this.knowledgeName = questionInfo.knowledge[0]['knowledge_name'];
              this.knowledgeCode = questionInfo.knowledge[0]['knowledge_code'];
            }

            // 题目基本信息
            this.q_forms = questionInfo.q_forms || questionInfo.question_form ;
            this.question_type = questionInfo.question_type;
            this.thoughts = questionInfo.thoughts || [];
            this.methods = questionInfo.methods || [];
            this.factors = questionInfo.factors || [];

            // 答题行为信息 - 映射新旧字段
            this.answer_behavior = {
              is_look_prompt: userExamDetailInfo.is_view_tips,
              is_view_answer: userExamDetailInfo.is_view_answer,
              answer_time: userExamDetailInfo.ts || userExamDetailInfo.answer_time,
              answer_duration: userExamDetailInfo.cost_time || userExamDetailInfo.answer_duration,
              skip_reason: userExamDetailInfo.skip_reason,
              is_look_prompt_result: userExamDetailInfo.is_look_prompt_result
            };

            this.lesson_id = res.data.lesson_id;

            // 听力音频处理
            const contentData = questionInfo.body || {};
            this.hearing = contentData.audio_data?.length ? contentData.audio_data : (questionInfo?.question_title?.body?.audio_data || []);
            this.hearing = this.hearing.filter(item => item.source_v2 || item.source);
            // 处理知识点考频、难度
            let knowledgeList = questionInfo.knowledge || [];
            const user_id = res.data.user_id;
            console.log('sessionStorage.getItem(user_id)', sessionStorage.getItem(user_id))
            if (sessionStorage.getItem(user_id) && sessionStorage.getItem(user_id) != 'undefined') {
              const currentCourseInfo = JSON.parse(sessionStorage.getItem(user_id)) || {};
              if (currentCourseInfo && currentCourseInfo.course_info) {
                this.currentCourseInfo = currentCourseInfo.course_info;
              }
            }
            const currentKnowledge = res.data.current_study_knowledge || {};
            if (Array.isArray(questionInfo.knowledge) && currentKnowledge.knowledge_code) {
              this.knowledgeVideo = questionInfo.knowledge.filter(item => item.knowledge_code === currentKnowledge.knowledge_code);
            }

            const questionDiff = this.getQuestionDiff(this.questionDetail?.question_info?.knowledge[0]?.textbook ?? []);

            if(questionDiff){
              this.question_frequency = questionDiff.weight_level ?? '';
              this.question_difficulty = questionDiff.diff_level ?? '';
            }


            this.getAnswerType(this.question_type);
            this.knowledge_info = questionInfo.knowledge || [];

            // 错因处理
            if (userExamDetailInfo.user_exam_detail_id || res.data.user_exam_detail_id) {
              this.user_exam_detail_id = userExamDetailInfo.user_exam_detail_id || res.data.user_exam_detail_id;
              this.error_reason_list = res.data.error_reason_list || [];
            }

            let multiSpaceRight = null;
            this.qanswerstatus = res.data.answer_status;
            if(this.qanswerstatus !== 3){
              console.log('%c this.qanswerstatus', 'color: red; font-weight: bold;', this.qanswerstatus)
              this.showAnswerList = true;
              // 多空填空数据处理，优先使用is_multi_space_right_format
              const isMultiSpaceRight = res.data.user_exam_detail_info && res.data.user_exam_detail_info.is_multi_space_right_format;

              if(isMultiSpaceRight){
                this.answerList = isMultiSpaceRight;
              } else if (res.data.user_exam_detail_info && res.data.user_exam_detail_info.is_multi_space_right) {
                // fallback：解析 is_multi_space_right JSON字符串

                const isMulti = this.parseJSONString(res.data.user_exam_detail_info.is_multi_space_right);
                if(typeof isMulti === 'object'){
                  this.answerList = Object.values(isMulti);
                } else {
                  this.answerList = isMulti;
                }
                console.log('%c this.answerList', 'color: red; font-weight: bold;font-size: 16px;', this.answerList)
              }
              if(this.question_type === 4){
                const studentAnswer = this.getStudentAnswer(userExamDetailInfo, res.data);
                const processedStudentAnswer = this.processUserAnswer(studentAnswer);
                this.judgeAnswer = processedStudentAnswer;
                const correctAnswer = this.getCorrectAnswer(questionInfo, res.data);
                // 处理判断题答案比较
                let studentAnswerValue = processedStudentAnswer;
                let correctAnswerValue = correctAnswer;

                // 如果是数组，取第一个元素
                if (Array.isArray(studentAnswerValue)) {
                  studentAnswerValue = studentAnswerValue[0];
                }
                if (Array.isArray(correctAnswerValue)) {
                  correctAnswerValue = correctAnswerValue[0];
                }

                if(correctAnswerValue === studentAnswerValue){
                  this.judgeIsright = true
                }else{
                  this.judgeIsWrong = true
                }
              }
            }

            // 题目内容处理
            this.titleContent = questionInfo.question_title && questionInfo.question_title.body && questionInfo.question_title.body.content || '';
            // this.titleContent = this.getQuestionTitleContent(questionInfo);
            this.qcontent = (contentData && contentData.content) || questionInfo.body && questionInfo.body.content || questionInfo.content || questionInfo.title_content || '';
            this.translationText = questionInfo.translation_text || res.data.translation_text || '';
            this.originalText = questionInfo.original_text || res.data.original_text || '';
            this.qimg = (contentData && contentData.img_data) || questionInfo.body && questionInfo.body.img_data || [];
            this.qOptions = questionInfo.options || questionInfo.option || res.data.options || [];

            // 正确答案处理
            this.qAnswer = this.getCorrectAnswer(questionInfo, res.data);


            // 学生答案处理
            const studentAnswer = this.getStudentAnswer(userExamDetailInfo, res.data);
            const processedStudentAnswer = this.processUserAnswer(studentAnswer);
            if (Array.isArray(processedStudentAnswer)) {
              let answerArray = processedStudentAnswer;
              let answerNewArray = [];
              answerArray.map(item => {
                if(item !== '') {
                  answerNewArray.push(item);
                } else {
                  answerNewArray.push(' ');
                }
              })
              this.myAnswer = answerNewArray;
            } else {
              this.myAnswer = processedStudentAnswer || '';
            }

            if (this.question_type == 1 ||this.question_type == 2) { // 多选
              if(Array.isArray(this.qOptions)) {
                  this.qOptions.forEach((option, index) => {
                    this.$set(option, "right", this.answerList[index] === "OK" || this.answerList[index] === "RIGHT");
                    this.$set(
                      option,
                      "wrong",
                      this.answerList[index] === "ERROR"
                    );
                    this.$set(
                      option,
                      "isAnswer",
                      this.answerList[index] === "STUDENT_NOT_SELECTED" ||
                      this.answerList[index] === "OK" || this.answerList[index] === "RIGHT"
                    );
                  });
                }
            } else if (this.question_type == 3) { // 填空题
              let fillBlocks = [];
              let fillNum = 0;
              // 优先使用新结构中的内容
              const contentText = this.qcontent || questionInfo.body && questionInfo.body.content;
              console.log('contentText', contentText)
              contentText.replace(/___\d*___/g, () => {
                // 兼容新格式的答案状态
                let answerStatus = this.answerList[fillNum];
                if (typeof answerStatus === 'string') {
                  answerStatus = answerStatus.toUpperCase();
                }

                fillBlocks.push({
                  right: answerStatus === "OK" || answerStatus === "RIGHT" || answerStatus === "NORMAL",
                  wrong: answerStatus === "ERROR",
                  isAnswer:
                    answerStatus === "STUDENT_NOT_SELECTED" ||
                    answerStatus === "OK" || answerStatus === "RIGHT" || answerStatus === "NORMAL"
                });
                ++fillNum;
              });
              this.questionfillBlocks = fillBlocks;
              console.log('%c this.questionfillBlocks', 'color: red; font-weight: bold;font-size: 16px;', this.qAnswer)
              this.qfillAnswer = this.processFillAnswer(this.qAnswer);
              console.log('%c this.qfillAnswer', 'color: red; font-weight: bold;font-size: 16px;', this.qfillAnswer)
            } else {
              this.myfillanswer = studentAnswer;
              this.myAnswer = processedStudentAnswer;
            }

            this.prompt = questionInfo.prompt || res.data.prompt;
            this.analyze = questionInfo.analyze || res.data.analyze || [];
            // 使用新的方法处理解析视频
            this.analyVideoArr = questionInfo.video_data || [];

            // 处理错因信息
            this.reason = questionInfo.reason || res.data.reason || [];

            let userNoDraft = true
            let userNoStepDraft = true
            if(Array.isArray(this.questionDetail.source)){
              this.questionDetail.source.forEach(item=>{
                if(item.source_use_type == 'step_draft'){
                  userNoStepDraft = false
                }
                if(item.source_use_type == 'draft'){
                  userNoDraft = false
                }
              })
            }
            this.userNoDraft = userNoDraft
            this.userNoStepDraft = userNoStepDraft
            this.errParams = {
              teacher_id: sessionStorage.getItem("teacher_id"),
              module_type: questionInfo.module_type,
              ai_cause_info:questionInfo.ai_cause_info || '',
              cause_info:questionInfo.cause_info || '',
              user_exam_detail_id:userExamDetailInfo.user_exam_detail_id || '',
              question_type:questionInfo.question_type,
              batch_num: questionInfo.batch_num,
              feedback_sence: 'SUPERVISE_V3_QUESTION_REASON',
              rs_type: 'QUESTION',
              rs_id: this.question_id,
              q_title_id: questionInfo.question_title_uuid || '',
              feed_id: '',
              feed_type: 'JSON_REF',
              rs_sys_ver: questionInfo.question_bank_version || 'V3',
              rs_version: questionInfo.question_vno,
              subject_id: this.subject_id,
              account_id: this.account_id,
              user_id: this.user_id,
              topic_id: this.topic_id,
              course_id: this.course_id,
              studyCard_id: questionInfo.study_card_id || '',
              user_answer: Array.isArray(this.myAnswer)? JSON.stringify(this.myAnswer) : this.myAnswer,
              detail_id: userExamDetailInfo.user_exam_detail_id,
              tag_code: questionInfo.knowledge && questionInfo.knowledge[0] && questionInfo.knowledge[0].tag_code || '',
              entity_type: 'NO_STUDY_QUESTION_REASON'
            }
            if ((this.currentViewStudent.learning_version == 2 && [2, 4, 5, 7].includes(this.currentViewStudent.subject_id)) || this.currentViewStudent.learning_version == 10) {
              this.getBoardImg() // 数学v2接入
            }
          }
        })
      },
      showAnalysis (type) {
        this.analysisType = type;
      },
      handoutVideo () {
        this.$router.push({ path: '/supervise/videoHandout', query: { }});
      },
      // 复制ID
      copyId (questionId) {
        this.$copyText(questionId).then(() => {
          this.$message({
            message: i18n.t('components.questionDetail.372231-37'),
            type: 'success',
            customClass: 'copy-success',
          });
        }, () => {
          this.$message({
            message: i18n.t('components.questionDetail.372231-38'),
            type: 'success'
          });
        })
      },
      getAnswerType(q_type) {

        let typeStr = '';
        if (this.q_forms == 2) {
          if (q_type == 1) {
            typeStr = i18n.t('components.questionDetail.372231-39');
          } else if (q_type == 2) {
            typeStr = i18n.t('components.questionDetail.372231-40');
          } else if (q_type == 3) {
            typeStr = i18n.t('components.questionDetail.372231-41');
          } else if (q_type == 4) {
            typeStr = i18n.t('components.questionDetail.372231-42');
          } else if (q_type == 5) {
            typeStr = i18n.t('components.questionDetail.372231-43');
          }
        } else {
          typeStr = i18n.t('components.questionDetail.372231-44');
        }

        this.question_type_str = typeStr;

      },
      //转换html字符串
      htmlDeCode(str) {
        // 文科
        if (this.subject_id == 1 || this.subject_id == 3) {
        //修改下划线问题，之前处理 border-bottom 修复，发现有问题，现在还原到之前的处理以防影响正常的展示！！！
          // if((str+'').includes('border-bottom')&&this.subject_id == 1){
          //   return str
          // }else{
          // }
          return htmlDecodeByRegExp(str);
        }
        return scienceHtmlDecodeByRegExp(str);
      },
      formatAnswer(str) {
        return decodeForAnswer(str, this.subject_id)
      },
      decode(str){
        let res =str
        if(!this.isNumber(res) && (res.indexOf('\(') == -1) && (res.indexOf('\[') == -1)){
          res ='\\('+res+'\\)'
        }
        return res
      },
      isNumber(val){
        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
        if(regPos.test(val) || regNeg.test(val)){
          return true;
        }else{
          return false;
        }
      },
      // 获取音频元素（缓存引用，避免重复查询）
      getAudioElements() {
        return {
          hearAudio: document.getElementById('myHearaudioDetail'),
          answerAudio: document.getElementById('myaudioDetail')
        };
      },
      // 初始化音频事件监听
      initAudioListeners() {
        const { hearAudio, answerAudio } = this.getAudioElements();
        
        if (hearAudio && !this.handleHearAudioEnd) {
          this.handleHearAudioEnd = () => {
            this.isHearPlay = false;
          };
          hearAudio.addEventListener('ended', this.handleHearAudioEnd);
        }
        
        if (answerAudio && !this.handleAudioEnd) {
          this.handleAudioEnd = () => {
            this.isPlay = false;
          };
          answerAudio.addEventListener('ended', this.handleAudioEnd);
        }
      },
      // 暂停另一个音频（确保同时只有一个音频播放）
      pauseOtherAudio(currentAudio, otherAudio, otherStateKey) {
        if (otherAudio && !otherAudio.paused) {
          otherAudio.pause();
          this[otherStateKey] = false;
        }
      },
      // 切换音频播放状态（播放/暂停）
      toggleAudioPlay(audioElement, stateKey, srcPath, srcKey, audioType) {
        if (!audioElement) return;
        
        // 确保事件监听器已绑定
        this.initAudioListeners();
        
        if (audioElement.paused) {
          // 先设置音频源，等待 Vue 更新 DOM
          this[srcKey] = srcPath;
          // 使用 nextTick 确保 DOM 更新完成后再播放
          this.$nextTick(() => {
            const { hearAudio, answerAudio } = this.getAudioElements();
            const targetAudio = audioType === 'hear' ? hearAudio : answerAudio;
            if (targetAudio) {
              targetAudio.play().catch(err => {
                console.error('音频播放失败:', err);
              });
              this[stateKey] = true;
            }
          });
        } else {
          // 暂停音频
          audioElement.pause();
          this[stateKey] = false;
        }
      },
      // 开始播放听力音频
      startHearPlay(srcPath) {
        const { hearAudio, answerAudio } = this.getAudioElements();
        if (!hearAudio) return;
        
        // 暂停答案音频（如果正在播放）
        this.pauseOtherAudio(hearAudio, answerAudio, 'isPlay');
        
        // 切换听力音频播放状态
        this.toggleAudioPlay(hearAudio, 'isHearPlay', srcPath, 'currentAudioHearingSrc', 'hear');
      },
      // 开始播放答案音频
      startPlay(srcPath) {
        const { hearAudio, answerAudio } = this.getAudioElements();
        if (!answerAudio) return;
        
        // 暂停听力音频（如果正在播放）
        this.pauseOtherAudio(answerAudio, hearAudio, 'isHearPlay');
        
        // 切换答案音频播放状态
        this.toggleAudioPlay(answerAudio, 'isPlay', srcPath, 'currentAudioSrc', 'answer');
      },
      // 点击知识点视频
      viewVideo(videoUrl) {
        let routeUrl = this.$router.resolve({
            path: "/supervise/viewVideo",
            query: {
              videoUrl: videoUrl,
            }
        });
        window.open(routeUrl.href, '_blank');
      },
      // 意见反馈
      gotoFeedBack () {
        window.open('https://teacher.test.classba.cn/feedback?key=1', "_blank");
      },
      // 查看知识点
      viewKnowledgeDetail() {
        let routeUrl = this.$router.resolve({
            path: "/supervise/videoHandout",
            query: {
              subject_id: this.subject_id,
              course_id: this.course_id,
              course_version: this.learning_version,
              knowledge_code: encodeURIComponent(this.knowledgeCode),
            }
        });
        window.open(routeUrl.href, '_blank');
      },
      imgclick(index){
        const viewer = this.$el.querySelector('.image-box').$viewer
        viewer.view(index)
      },
      imgOpen(url){
        window.open(url)
      },
      getBoardImg () {
        let params = {
          subject_id: this.subject_id,
          user_type: 1,
          account_id: this.account_id,
          user_id: this.user_id || '',
          course_id: this.course_id,
          course_version: this.learning_version == 3 ? 10 : this.learning_version,
          lesson_id: this.lesson_id,
          study_card_id: this.questionDetail.study_card_id,
          question_id: this.questionDetail.question_info && this.questionDetail.question_info.question_uuid,
          question_vno: this.questionDetail.question_info && this.questionDetail.question_info.question_vno,
          question_bank_version: this.questionDetail.question_info && this.questionDetail.question_info.question_bank_version,
          user_exam_detail_id: this.questionDetail.user_exam_detail_info && this.questionDetail.user_exam_detail_info.user_exam_detail_id,
        }
        getBoardImg(params).then(res => {
          if (res.code === 200) {
            this.auxiliaryImgUrl = res.data.url || ''
            this.setImgSize();
          }
        });
      },
      setImgSize () {
        const _that = this;
        let img = new Image()
        img.src = this.auxiliaryImgUrl
        img.onload = function () {
          const w = img.width;
          const h = img.height;
          let imgW = 0, imgH = 0;
          if (w > h) {
            imgW = '100%'
            imgH = 'auto'
          } else {
            imgW = 'auto'
            imgH = '100%'
          }
          _that.auxiliaryImgSize = {
            w: imgW,
            h: imgH
          }
        }
      },
      // 判断学生答案的样式
      judgeStudentAnswer(index) {
        let classResult = 'multi-space';
        if (this.isMultiSpaceRight.length > 0) {
          let result = this.isMultiSpaceRight[index];
          classResult = result == 'OK' ? 'multi-space OK' : 'multi-space ERROR';
        }
        return classResult;
      },
      getStudentAnswer(userExamDetailInfo, resData) {
        // 优先使用新结构中的用户答案
        if (userExamDetailInfo.user_answer_format) {
          let userAnswer = userExamDetailInfo.user_answer_format;
          if (typeof userAnswer === 'number') {
            userAnswer = String(userAnswer);
          }
          if (typeof userAnswer === 'string') {
            try {
              userAnswer = JSON.parse(userAnswer);
            } catch (e) {
              return userAnswer;
            }
          }
          
          return userAnswer;
        } else if (userExamDetailInfo.user_answer) {
          let userAnswer = userExamDetailInfo.user_answer;
          if (typeof userAnswer === 'string') {
            try {
              userAnswer = JSON.parse(userAnswer);
            } catch (e) {
              return userAnswer;
            }
          }
          return userAnswer;
        }

        // 兼容旧结构
        return resData.student_answer;
      },
      getCorrectAnswer(questionInfo, resData) {
        // 优先使用新结构中的答案
        if (questionInfo.answer) {
          let answer = questionInfo.answer;
          // 新结构是数组套对象，需要提取content
          if (Array.isArray(answer) && answer.length > 0) {
            if (this.question_type === 3) {
              // 填空题使用专门的填空题答案处理
              return this.processFillAnswer(answer);
            } else {
              // 选择题使用选择题答案处理
              return this.processChoiceAnswer(answer);
            }
          }
          return answer;
        }

        // 兼容旧结构
        return resData.answer;
      },

      // 解析JSON字符串格式的数据
      parseJSONString(value) {
        if (!value) return value;

        // 如果已经是数组或对象，直接返回
        if (typeof value !== 'string') {
          return value;
        }

        // 如果是字符串形式的JSON数组，尝试解析
        if (value.startsWith("[") || value.startsWith("{")) {
          try {
            const parsed = JSON.parse(value);
            return parsed;
          } catch (e) {
            console.warn('解析JSON字符串失败:', value, e);
            // 如果JSON解析失败，尝试处理转义字符问题
            try {
              // 处理双重转义的引号：\" -> "
              let cleanedValue = value.replace(/\\"/g, '"');
              // 处理可能的其他转义字符
              cleanedValue = cleanedValue.replace(/\\\\/g, '\\');
              const parsed = JSON.parse(cleanedValue);
              return parsed;
            } catch (e2) {
              console.warn('二次解析JSON字符串失败:', value, e2);
              // 如果还是失败，尝试更激进的清理
              try {
                // 移除外层的引号（如果存在）
                let finalValue = value;
                if ((finalValue.startsWith('"') && finalValue.endsWith('"')) ||
                    (finalValue.startsWith("'") && finalValue.endsWith("'"))) {
                  finalValue = finalValue.slice(1, -1);
                }
                // 再次处理转义字符
                finalValue = finalValue.replace(/\\"/g, '"').replace(/\\\\/g, '\\');
                const parsed = JSON.parse(finalValue);
                return parsed;
              } catch (e3) {
                console.warn('最终解析JSON字符串失败:', value, e3);
                // 继续尝试其它格式
              }
            }
          }
        }

        // 处理分号分隔的简单字符串，例如："pencil;case" 或包含中文分号 "pencil；case"
        // 拆分后去除首尾空格与包裹引号
        const hasSemicolon = value.indexOf(';') !== -1 || value.indexOf('；') !== -1;
        if (hasSemicolon) {
          const normalizePart = (s) => {
            let t = s.trim();
            if ((t.startsWith('"') && t.endsWith('"')) || (t.startsWith("'") && t.endsWith("'"))) {
              t = t.slice(1, -1).trim();
            }
            return t;
          };
          const parts = value.split(/[;；]/).map(normalizePart).filter(s => s.length > 0);
          if (parts.length > 1) {
            return parts;
          }
        }

        return value;
      },

      // 处理用户答案格式，统一使用user_answer_format
      processUserAnswer(userAnswerData) {
        if (!userAnswerData) return '';
        // 如果传入的是JSON字符串，先解析
        let parsedData = userAnswerData;
        if (typeof userAnswerData === 'string') {
          parsedData = this.parseJSONString(userAnswerData);
        }
        // 如果解析后是数组
        if (Array.isArray(parsedData)) {
          // 检查是否是对象数组格式：[{content: "A", position: "1"}]
          if (parsedData.length > 0 && typeof parsedData[0] === 'object' && parsedData[0] !== null) {
            if(!parsedData[0].content){
              return '';
            }
            // 按 position 排序（如果有的话），然后提取 content
            if(Array.isArray(parsedData[0].content) && parsedData[0].content.length == 1 && parsedData[0].content[0] == ''){
              return '';
            }
            // 按 position 排序（如果有的话），然后提取 content
            const sortedAnswers = parsedData.sort((a, b) => {
              const posA = parseInt(a.position || 0);
              const posB = parseInt(b.position || 0);
              return posA - posB;
            });
            return sortedAnswers.map(item => item.content);
          }
          // 如果是字符串数组格式：["12", "", ""] 或其他简单数组格式
          else {
            return parsedData;
          }
        }

        // 如果是单个对象格式：{content: "A", position: "1"}
        if (typeof parsedData === 'object' && parsedData.content !== undefined) {
          return [parsedData.content];
        }

        // 其他情况直接返回
        return parsedData;
      },

      // 处理填空题答案格式
      processFillAnswer(answer) {
        if (!answer || !Array.isArray(answer)) return [];

        // 如果是嵌套数组格式 [[{content: "xxx"}], [{content: "yyy"}]]
        if (Array.isArray(answer[0])) {
          return answer.map((answerGroup, groupIndex) => {
            if (Array.isArray(answerGroup)) {
              return answerGroup.map(item => ({
                content: item.content ?? item
              }));
            }
            // 如果单个元素不是数组，包装成数组
            return [{
              content: answerGroup.content ?? answerGroup
            }];
          });
        }

        // 如果是简单数组格式 [{content: "xxx"}, {content: "yyy"}]
        // 假设每个元素是一个填空的答案
        return answer.map(item => [{
          content: item.content ?? item
        }]);
      },

      // 处理选择题答案格式
      processChoiceAnswer(answer) {
        if (!answer || !Array.isArray(answer)) return '';

        // 如果是嵌套数组格式 [[{content: "xxx"}]]
        if (Array.isArray(answer[0])) {
          if (answer[0][0] && answer[0][0].content) {
            return answer[0][0].content;
          }
        }

        // 如果是简单数组格式 [{content: "xxx"}]
        if (answer[0] && answer[0].content) {
          return answer[0].content;
        }

        // 直接返回第一个元素
        return answer[0] || '';
      },


      formatAnswerTime(time) {
        if (!time) return '00:00:00';
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = Math.floor(time % 60);
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      },
      getQuestionTitleContent(questionInfo) {
        if (!questionInfo) {
          return '';
        }

        let title = '';
        let body = '';

        // 调试信息
        console.log('questionInfo:', questionInfo);
        console.log('questionInfo.question_title:', questionInfo.question_title);
        if (questionInfo.question_title) {
          console.log('questionInfo.question_title.body:', questionInfo.question_title.body);
          if (questionInfo.question_title.body) {
            console.log('questionInfo.question_title.body.content:', questionInfo.question_title.body.content);
          }
        }

        // 安全地获取 question_title
        if (questionInfo.question_title && questionInfo.question_title.body && questionInfo.question_title.body.content) {
          console.log('xxxdddsdsds-2')
          title = questionInfo.question_title.body.content;
        }
        console.log('titlexxxxx', title)
        // 安全地获取 body content
        if (questionInfo.body && questionInfo.body.content) {
          body = questionInfo.body.content;
        }

        // 拼接 title 和 body，如果都有内容则用空格分隔
        if (title && body) {
          return title + ' ' + body;
        } else if (title) {
          return title;
        } else if (body) {
          return body;
        } else {
          return '';
        }
      },

    },
    filters: {
      formatTime (s) {
        let result = '';
        if (s == 0) {
          result = i18n.t('components.questionDetail.791473-45');
        } else {
          var day = Math.floor( s/ (24*3600) ); // Math.floor()向下取整
          var hour = Math.floor( (s - day*24*3600) / 3600);
          var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 );
          var second = s - day*24*3600 - hour*3600 - minute*60;
          second = Math.floor(second);

          if (day > 0) {
            result = i18n.t('components.questionDetail.791473-46', [day])
          }

          if (hour > 0) {
            result += i18n.t('components.questionDetail.791473-47', [hour])
          }

          if (minute > 0) {
            result += i18n.t('components.questionDetail.791473-48', [minute])
          }

          if (second > 0) {
            result += i18n.t('components.questionDetail.791473-49', [second])
          }
        }
        // return day + "天"  + hour + "时" + minute + "分" + second + "秒";
        return result;
      },
    },
    watch:{
      questionId (value) {
        this.question = value
      },
    },
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/theme-chalk/common/var";
  @import "~@/assets/theme-chalk/mixins/utils";
  @import "~@/assets/scss/var";
  @import "~@/assets/scss/mixins";
  .question-detail {
    .detail-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      .blue-block {
        display: inline-block;
        width: 4px;
        height: 16px;
        vertical-align: text-top;
        background: #2980ff;
      }
      .title-text {
        font-size: 18px;
        color: #444b65;
        letter-spacing: 0;
        font-weight: bold;
      }
      .right-feedback {
        margin-right: 10px;
      }
    }
    .question-info {
      margin-top: 9px;
      background: #fff;
      border: 1px solid #d3d8e8;
      border-radius: 6px;
      .info-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // height: 48px;
        min-height: 48px;
        padding: 0 24px;
        background: #fafcfd;
        .left-side {
          display: flex;
          width: 600px;
          font-size: 14px;
          color: #444b65;
          .link {
            font-size: 14px;
            color: #2980ff;
            letter-spacing: 0;
            cursor: pointer;
            &:hover {
              opacity: .8;
            }
          }
          .knwoledge-name-box {
            display: flex;
          }
          .knwoledge-name {
            display: block;
            max-width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:hover {
              cursor: pointer;
            }
          }
        }
        .right-side {
          .right-side-ul {
            display: flex;
            align-items: center;
            height: 28px;
            // overflow: hidden;
            li {
              float: left;
              &.type {
                span {
                  margin-right: 3px;
                }
              }
              span {
                font-size: 14px;
                color: #444b65;
                letter-spacing: 0;
              }
              &:last-child {
                &:after {
                  display: none;
                }
              }
              &:after {
                display: inline-block;
                width: 1px;
                height: 16px;
                margin: 0 10px;
                vertical-align: -3px;
                content: "";
                background-color: #444b65;
              }
            }
          }
        }
      }
      .question-content {
        margin: 9px 30px 24px 30px;
        font-size: 14px;
        line-height: 24px;
        color: #444b65;
        text-align: justify;
        letter-spacing: 0;
        /deep/ img {
          max-width: 100%;
        }
        .translation-text{
          background: rgba(222,229,240, 0.3);
          border-radius: 6px;
          padding: 16px;
          margin: 16px 0;
          font-size: 16px;
        }
        .title {
          margin: 9px 0 30px 0;
          text-align: center;
        }
        .options-wrap {
          margin: 40px 40px 0 0;
          font-size: 0;
          list-style: none;
          .options-wrap__inner {
            display: flex;
            align-items: center;
          }
          .option-item {
            position: relative;
            padding: 13px;
            margin-bottom: 16px;
            cursor: pointer;
            background: #fff;
            border: 1px solid #f2f2f2;
            border-radius: 4px;
            &.selected {
              border: 1px solid #35a7ff;
            }
            &.isAnswer {
              border: 1px solid #daf1a6;
            }
            &.wrong {
              border: 1px solid #fdd5d5;
            }
            .status-icon {
              position: absolute;
              top: 50%;
              right: -20px;
              display: block;
              width: 40px;
              height: 40px;
              margin-top: -20px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .option-num {
            padding: 0 10px 0 0;
            font-size: 16px;
            line-height: 16px;
            color: #302d27;
            text-align: center;
          }
          .option-content-wrap {
            padding-left: 10px;
            font-size: 16px;
            line-height: 16px;
            color: #302d27;
            word-break: break-word;
            border-left: 1px solid #f2f2f2;
            .option-content {
              display: inline-block;
              /*width: 320px;*/
            }
            .option-img {
              display: block;
              margin-top: 10px;
            }
          }
        }

        .fillblock-wrap {
          padding-top: 24px;
          .fillblock {
            position: relative;
            box-sizing: border-box;
            // width:380px;
            width: auto;
            height: auto;
            min-height: 48px;
            padding: 0 18px;
            margin-bottom: 18px;
            background: rgba(255,255,255,1);
            border: 3px solid rgba(242,242,242,1);
            border-radius: 4px;
            img.kfformula {
              width: auto;
              height: 100%;
              margin-top: -6px;
            }
            .index {
              position: absolute;
              top: 50%;
              left: 10px;
              display: inline-block;
              width: 20px;
              height: 20px;
              margin-top: -10px;
              margin-right: 8px;
              font-size: 12px;
              line-height: 20px;
              color: #fff;
              text-align: center;
              vertical-align: top;
              background: #ccc;
              border-radius: 50%;
            }
            input {
              position: relative;
              top: -6px;
              flex: 1;
              width: 250px;
              height: 100%;
              padding-left: 25px;
              margin-top: 6px;
              font-size: 16px;
              line-height: 28px;
              color: rgba(48,45,39,1);
              text-align: justify;
              letter-spacing: 0;
              background: transparent;
              border: none;
              outline: none;

              -webkit-appearance: none;
            }
            .answer-editor {
              display: flex;
              align-items: center;
              width: 285px;
              height: 100%;
              padding-left: 4px !important;
              margin-top: 2px;
              margin-left: 20px;
              background: rgba(0, 0, 0, 0) !important;
              border: none;

              @include ellipsis();
            }
            .right-wrong-icon {
              position: absolute;
              top: 50%;
              right: -20px;
              display: block;
              width: 40px;
              height: 40px;
              margin-top: -20px;
              img {
                width: 100%;
              }
            }
          }
          .fillblock1 {
            .status-icon {
              position: absolute;
              top: 50%;
              right: -20px;
              display: block;
              width: 40px;
              height: 40px;
              margin-top: -20px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            input {
              padding-left: 0;
            }
          }
          .fillblock.right {
            border: 3px solid #daf1a6;
          }
          .fillblock.wrong {
            border: 3px solid #fdd5d5;
          }
          .fill {
            padding-left: 20px;
            overflow: hidden;
            font-size: 16px;
            line-height: 46px;
            color: #333;
            text-align: justify;
            letter-spacing: 0;
            word-break: break-all;
            word-break: break-word;
          }
        }
      }
      .ques-devider {
        height: 1px;
        background: #d3d8e8;
      }
      .answer-content {
        .answer-header {
          display: flex;
          align-items: center;
          height: 48px;
          padding-left: 24px;
          font-size: 16px;
          color: #444b65;
          letter-spacing: 0;
          background: #fafcfd;
          .topic-order{
            font-size: 14px;
            font-weight: bold;
            color: #2980FF;
            line-height: 28px;
            margin-left: 8px;
          }
        }
        .submit-answer-info {
          margin: 13px 0 0 29px;
          .imagebox{
            img{
              max-width: 100%;
              max-height: 100%;
              margin: 0;
            }
          }
          .label-item {
            font-size: 14px;
            color: #858a9b;
          }
          .time {
            font-size: 14px;
            color: #a7b2d2;
          }
          .text-value {
            font-size: 14px;
            color: #000029;
            &.tips {
              color: #444b65;
            }
          }
          .submit-item {
            margin-bottom: 16px;
            color: #858a9b;
            .submit-module {
              overflow: hidden;
              li {
                float: left;
                margin-right: 30px;
                .question-time {
                  color: #444b65;
                }
              }
              .correct-answer-wrap {
                display: flex;
                align-items: center;
                margin-left: 0px;
                margin-top: 5px;
                .first-submit-myanswer {
                  min-width: 80px;
                }
              }
            }
            .answer-show {
              display: flex;
              .answer-show-myanswer {
                min-width: 80px;
              }
              .answer-list {
                max-width: 1000px;
                .katex-answer {
                  min-width: 30px;
                }
              }
              .comma {
                margin-right: 10px;
              }
              .answer-list-flex{
                display: flex;
              }
              .margin-6{
                margin: 0 6px;
              }
              .my-answer-format {
                display: flex;
                align-items: center;
                max-width: 1000px;
                color:#444b65;
                .multi-space {
                  display: inline-block;
                  &.OK {

                  }
                  &.ERROR {
                    color: #ff4757;
                  }
                }
                .comma {
                  color: #444b65;
                }
              }
              .right-answer {
                display: flex;
                color: #444b65;
              }
            }
          }
          /deep/ .error-reason-wrap
            {
              padding: 0 20px 20px 0;
              display: flex;
              .mark{
                width: 90px;
                color: #858a9b;
              }
              .qs-wrong-because {
                margin-top: 0;
              }
            }
        }
        .answer-info {
          padding-bottom: 16px;
          margin: 13px 0 0 29px;
        }
      }
      &.en-question-info {
        .info-header {
          flex-wrap: wrap;
          .left-side {
            width: 100%;
          }
        }
      }
    }
    .module-header-title {
      font-size: 18px;
    }
    .question-analysis {
      margin-top: 31px;

      .analysis-info {
        margin-top: 11px;
        background: #fff;
        border: 1px solid #d3d8e8;
        border-radius: 6px;
        .analysis-header {
          display: flex;
          align-items: center;
          height: 48px;
          padding-left: 24px;
          background: #fafcfd;
          li {
            box-sizing: border-box;
            float: left;
            min-width: 90px;
            height: 48px;
            font-size: 16px;
            line-height: 48px;
            color: #444b65;
            text-align: center;
            letter-spacing: 0;
            cursor: pointer;
            &:hover {
              opacity: .8;
            }
            &.active {
              font-weight: 500;
              color: #2980ff;
              border-bottom: 2px solid #2980ff;;
            }
          }
        }
        .analysis-text {
          margin: 16px 23px;
          font-size: 14px;
          line-height: 25px;
          color: #606b7d;
          text-align: justify;
          letter-spacing: 0;
          .analysis-section {
            display: flex;
            /*width: 720px;*/
            margin-bottom: 10px;
            .label-text {
              min-width: 80px;
              margin: 0 10px 0 0;
            }
            .tu-wen-text {
              max-width: 1000px;
              /deep/ img {
                  max-width: 100%;
                }
            }
            .video-ul {
              li {
                float: left;
                margin-right: 14px;
              }
            }
          }
          .no-prompt {
            height: 40px;
          }
        }
      }
    }
    .sing-reason {
      margin-top: 28px;
      .reason-info {
        position: relative;
        margin-top: 11px;
        background-image: linear-gradient(-180deg, #fff 0%, #f1f9ff 100%);
        border: 1px solid #dee5f0;
        .title {
          margin-right: 10px;
          font-size: 14px;
          color: #606b7d;
        }
        .reason-list {
          margin: 37px 0 0 29px;
          .reason-1 {
            margin-right: 10px;
          }
          .reason-2 {
            margin-right: 17px;
          }
        }
        .reason-count {
          display: flex;
          align-items: center;
          margin: 21px 0 38px 29px;
          .reason-item-ul {
            li {
              float: left;
              margin-right: 5px;
              .reason-text {
                font-size: 12px;
                color: #606b7d;
              }
            }
          }
        }
        .error-reason-bg {
          position: absolute;
          top: 10px;
          right: 29px;
          width: 296px;
          height: 130px;
          background: url("~@/assets/images/error_reason.png") no-repeat center;
          background-size: 100%;
        }
      }
    }
    .mcm-module {
      margin-top: 25px;
      .mcm-info {
        margin-top: 11px;
        background: #fff;
        border: 1px solid #d3d8e8;
        border-radius: 6px;
        .mcm-header {
          display: flex;
          align-items: center;
          height: 48px;
          padding-left: 24px;
          font-size: 16px;
          color: #444b65;
          letter-spacing: 0;
          background: #fafcfd;
        }
        .mcm-content {
          margin: 30px 0 34px 0;
          .single-mcm {
            display: flex;
            align-items: center;
            justify-content: start;
            padding-left: 24px;
            margin-bottom: 24px;
          }
          .title {
            font-size: 16px;
            color: #444b65;
            letter-spacing: 0;
          }
          .mcm-content-ul {
            margin-left: 32px;
            li {
              float: left;
              padding: 3px 42px;
              margin-right: 24px;
              font-size: 16px;
              letter-spacing: 0;
              border-radius: 4px;
              &.thought {
                color: #ffba00;
                background: #fff7df;
              }
              &.ability {
                color: #46c935;
                background: #e6f8e4;
              }
              &.function {
                color: #0dc8fa;
                background: #d9f6fe;
              }
            }
          }
        }
      }
    }
  }
  .flex-line{
    line-height: 35px;
  }
  .audio-box {
    position: relative;
    display: inline-block;
    width: 35px;
    height: 35px;
    background-color: #2980ff;
    border-radius: 50%;
    .audio-player {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      width: 35px;
      height: 35px;
    }
  }
  .detail-ul{
    margin-top: 11px;
    padding: 24px;
    background: #fff;
    border: 1px solid #d3d8e8;
    border-radius: 6px;
  }
  .detail-item-auxiliary{
    display: flex;
    .imagebox {
      position: relative;
      width: 150px;
      height: 150px;
      cursor: pointer;
      .image-box2 {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        .mask {
          flex: none;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 1);
          opacity: 0;
          position: relative;
          &:hover {
            opacity: .5;
          }
        }
      }
      .image-box {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        border: 1px solid #CCCCCC;
        >img{
          max-width: 100%;
          max-height: 100%;
          margin: 0;
        }
      }
      .icon-fdj {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 28px;
        height: 24px;
        margin-top: -12px;
        margin-left: -14px;
        background-image: url("~@/assets/images/icon_fdj.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
      }
    }
  }
  .detail-item-auxiliary1{
    flex-wrap: wrap;
    align-items: center;
    .margin-bottom-32{
      margin-bottom: 32px;
    }
    .margin-right-24{
      margin-right: 24px;
    }
    .imagebox1 {
      margin: 0 16px 32px 0;
      p{
        text-align: center;
        margin-top: 8px;
      }
    }
  }

  .image-ul-list {
    margin-top: 16px;
    li {
      float: left;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/questionDetail.vue